import cloneDeep from 'lodash.clonedeep';
import { itemTypeCounter } from './itemTypeCounter';

export const injectedArray = (() => {
  let arr = [];

  return {
    add: (item) => arr.push(item),
    delete: () => {
      arr = [];
    },
    get: () => arr,
    pop: () => arr.pop(),
  };
})();

export const injectInsideArrayObj = (injectInsideItem, el) => {
  const lastObjInjectedArr = injectedArray.pop();
  const clonedObj = lastObjInjectedArr && cloneDeep(lastObjInjectedArr);
  const arrToInject = clonedObj && clonedObj[injectInsideItem.key];

  if (arrToInject) {
    arrToInject.splice(injectInsideItem.index, 0, el);
    injectedArray.add(clonedObj);
  }
};

const injectBasedOnRules = (
  rulesForComponentToBeInjected,
  amp,
  bodyElements,
  bodyIndex,
  currentBlockType,
  // eslint-disable-next-line default-param-last
  props = {},
  wordCount,
) => {
  itemTypeCounter.addToCurrentItemTypeCount(currentBlockType);

  if (currentBlockType === 'TEXT') itemTypeCounter.addToCurrentItemTypeCount('wordCount', wordCount);

  rulesForComponentToBeInjected.forEach((componentRule) => {
    const {
      componentType: ruleComponentType,
      condition,
      component,
      id,
      resetCurrentItemTypeCurrentCounter = false,
      injectInsideItem = {},
    } = componentRule;

    const shouldInjectInsideArrayObj = injectInsideItem.index !== undefined && injectInsideItem.index !== null;

    if (id && currentBlockType === 'TEXT' && wordCount && wordCount > 0) {
      itemTypeCounter.addToCurrentItemTypeCount(`${id}.wordCount`, wordCount);
    }

    const options = {
      amp,
      bodyElements,
      bodyIndex,
      currentRuleInjectedComponentCount: itemTypeCounter.getCurrentItemTypeTotalCount(ruleComponentType),
      currentRuleComponentTypeWordCount: itemTypeCounter.getCurrentItemTypeCurrentCount(`${id}.wordCount`),
      currentType: currentBlockType,
      currentTypeCurrentCount: itemTypeCounter.getCurrentItemTypeCurrentCount(currentBlockType),
      currentTypeTotalCount: itemTypeCounter.getCurrentItemTypeTotalCount(currentBlockType),
      injectedArray: injectedArray.get(),
      nextType: bodyElements[bodyIndex + 1] ? bodyElements[bodyIndex + 1].type : null,
      prevType: bodyElements[bodyIndex - 1] ? bodyElements[bodyIndex - 1].type : null,
      props,
      totalWordCount: itemTypeCounter.getCurrentItemTypeCurrentCount('wordCount'),
    };

    const componentPassesCondition = condition(options);

    if (componentPassesCondition) {
      itemTypeCounter.addToCurrentItemTypeCount(ruleComponentType);
      const componentCount = itemTypeCounter.getCurrentItemTypeTotalCount(ruleComponentType);
      const componentArgs = { ...props, componentCount };

      component(componentArgs).forEach((el) => {
        if (shouldInjectInsideArrayObj) {
          injectInsideArrayObj(injectInsideItem, el);
        } else {
          injectedArray.add(el);
        }
      });

      if (resetCurrentItemTypeCurrentCounter) {
        itemTypeCounter.resetCurrentCount(currentBlockType);
        itemTypeCounter.resetCurrentCount(`${id}.wordCount`);
      }
    }
  });
};

const loopThroughBodyBlockAndInjectItems = (
  bodyArray,
  rulesForComponentToBeInjected,
  amp,
  props,
) => {
  injectedArray.delete();

  bodyArray.forEach((item, bodyIndex, bodyElements) => {
    const { type: currentBlockType, wordCount } = item;

    injectedArray.add(item);

    injectBasedOnRules(
      rulesForComponentToBeInjected,
      amp,
      bodyElements,
      bodyIndex,
      currentBlockType,
      props,
      wordCount,
    );
  });
};

/**
 * Returns array with injected items based on
 * injection rules supplied.
 * @param {Array} body - Array where we inject items.
 * @param {Array} rules - Array of injection rules used to inject items.
 * @param {Boolean} amp - Whether the page is amp or not.
 * @param {Object} props - Props that might need to be passed to the component to be injected.
 * @returns {Array}
 */
const injectionEngine = (
  {
    body,
    rules,
    amp = false,
    props = {},
  },
) => (() => {
  if (!rules) {
    return body;
  }

  loopThroughBodyBlockAndInjectItems(
    body,
    rules,
    amp,
    props,
  );

  itemTypeCounter.deleteItems();
  return injectedArray.get();
})();

export default injectionEngine;
